import React, {memo} from 'react';
import dynamic from 'next/dynamic';
import MUIBox from '@/components/MUI-Components/MUI-Box';
import MUIGrid from '@/components/MUI-Components/MUI-Grid';
import MUIButton from '@/components/MUI-Components/MUI-Button';
import Link from 'next/link';
const DisplayImage = dynamic(import('@/components/Ui-components/display-image'));

const sxBlockchainLayoutNav = {
    justifyContent: 'space-between',
    alignItems: 'center'
};

const sxPillarLogo = {
    width: '126px', // no exact spacing-token match
    height: 'auto',
    '@media (max-width: 430px)': {
        width: '100px' // no exact spacing-token match
    }
};

const NavBar = (props: any) => {
    const {logo} = props;

    return (
        <MUIGrid container spacing={2} className="nav_grid" sx={sxBlockchainLayoutNav}>
            <MUIGrid item>
                <MUIBox>
                    <Link href="/">
                        <MUIBox
                            component={DisplayImage}
                            src={logo}
                            alt="Debut infotech"
                            width={126}
                            height={60}
                            priority={true}
                            sx={sxPillarLogo}
                        />
                    </Link>
                </MUIBox>
            </MUIGrid>
            <MUIGrid item className="header-contact-btn">
                <Link href="/contact-us" className="menu-links" prefetch={false}>
                    <MUIButton className="helper-card-button" variant="contained" label="Contact Us" />
                </Link>
            </MUIGrid>
        </MUIGrid>
    );
};

export default memo(NavBar);
